export class ActionForm {
  public title: string;
  public reference: boolean;
  public street: boolean;
  public houseNumber: boolean;
  public postalCode: boolean;
  public city: boolean;
  public country: boolean;
  public phoneNumber: boolean;
  public email: string;
  public extraField: boolean;
  public extraFieldName: string;
}
